import { Component, OnInit } from '@angular/core';
import { MenuItem, MessageService } from 'primeng/api';
import { User } from './models';
import { Roles } from './models/roles';
import { AccountService } from './services';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css']
})
export class AppComponent implements OnInit {

  items: MenuItem[];

  title = 'Autocolor';

  user: User;

  constructor(
    private accountService: AccountService,
    private messageService: MessageService,) {
    this.accountService.user.subscribe(x => {
      this.user = x;
      this.llenarMenu();
    });
  }

  async ngOnInit() {
    await this.accountService.login();
  }

  llenarMenu() {

    if (!this.user) { return }

    this.items = [
      {
        label: 'Inicio',
        icon: 'pi pi-fw pi-home',
        routerLink: "/",
      },
      {
        label: 'Opciones',
        visible: this.user.rol.id < Roles.PAIS,
        icon: 'pi pi-fw pi-cog',
        items: [
          {
            label: 'Colores',
            icon: 'pi pi-fw pi-palette',
            items: [
              {
                label: 'Buscar',
                icon: 'pi pi-fw pi-search',
                routerLink: "/admin/colores"
              },
              {
                label: 'Agregar',
                icon: 'pi pi-fw pi-plus',
                routerLink: "/admin/colores/add"
              },
              {
                label: 'Carga Masiva',
                icon: 'pi pi-fw pi-upload',
                routerLink: "/admin/colores/cargar"
              }
            ],
          },
          {
            label: 'Formulas',
            icon: 'pi pi-fw pi-list',
            routerLink: "/formulas",
          },
          {
            label: 'Tintes',
            icon: 'pi pi-fw pi-th-large',
            items: [
              {
                label: 'Editar tintes',
                icon: 'pi pi-fw pi-pencil',
                routerLink: "/admin/tintes",
              },
              {
                label: 'Reemplazar Tinte',
                icon: 'pi pi-fw pi-clone',
                routerLink: "/admin/tintes/reemplazar"
              },
              {
                label: 'Conversion Sistemas',
                icon: 'pi pi-arrow-right-arrow-left',
                routerLink: "/admin/tintes/conversion"
              }
            ]
          },
          {
            label: 'Fabricantes',
            icon: 'pi pi-fw pi-briefcase',
            routerLink: "/admin/fabricantes",
          },
          {
            label: 'Sistemas',
            icon: 'pi pi-fw pi-bars',
            routerLink: "/admin/sistemas",
          },
          {
            label: 'Pictogramas',
            icon: 'pi pi-images',
            routerLink: "/admin/pictograma-detail"
          },
          // {
          //   label: 'Delete',
          //   icon: 'pi pi-fw pi-trash'
          // },
          // {
          //   separator: true
          // },
          // {
          //   label: 'Export',
          //   icon: 'pi pi-fw pi-external-link'
          // }
        ]
      },
      {
        label: 'Monitor',
        visible: this.user.rol.id < Roles.PAIS,
        icon: 'pi pi-fw pi-file',
        items: [
          {
            label: 'Consulta de Fórmulas',
            icon: 'pi pi-fw pi-desktop',
            routerLink: "/reportes/uso"
          },
          {
            label: 'Notificaciones',
            icon: 'pi pi-fw pi-envelope',
            routerLink: "/notificaciones"
          }
        ]
      },
      {
        label: 'Usuarios',
        icon: 'pi pi-fw pi-user',
        items: [
          {
            label: 'Usuarios...',
            icon: 'pi pi-fw pi-users',
            routerLink: "/users",
            visible: this.user.rol.id < Roles.USUARIO,
          },
          {
            label: 'Clientes',
            icon: 'pi pi-fw pi-briefcase',
            routerLink: "/admin/clientes",
            visible: this.user.rol.id < Roles.CLIENTE,
          },
          {
            label: 'Paises',
            icon: 'pi pi-fw pi-globe',
            routerLink: "/admin/paises",
            visible: this.user.rol.id < Roles.PAIS,
          },
          {
            separator: true
          },
          {
            label: 'Cambiar Contraseña',
            icon: 'pi pi-fw pi-key',
            routerLink: "/users/password"
          },

        ]
      }
      /* ,
      {
        label: this.user.nombre
      }
      {
        label: 'Salir',
        icon: 'pi pi-fw pi-power-off',
        command: (click) => { this.logout() }
      }
      */
    ];

  }

  logout() {
    this.accountService.logout();
  }

}
